import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';
import NotificationService from 'NotificationService.js';
import contentTemplate from 'reset-password-view.ejs';
import RestService from 'RestService.js';
import util        from 'util/Util.js';
import configService  from 'ConfigService';
import restService  from 'RestService.js';

class ResetPasswordView extends View {
//
    initialize( opts ) {
        this.options = opts || {};

        $(this.el).off('submit');
        $(this.el).off('change');
        $(this.el).off('click');
        $(this.el).off('keyup');

        this.template = contentTemplate;
        this.events = {
            'click #resetPasswordSubmit': 'resetPass',
            'click #backToLogin, #resetLogin': 'backToLogin',
            'keyup #newPassword, #repeatPassword': 'validatePasswords'
        };

        this.model.set('newPassword', '');
        this.model.set('email', '');

        let title = 'Reset Password';
        if (this.model.get('code') !== '0') {
            title = 'Password-Link';
        }
        this.model.set('title', title, {silence: true});

        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePasswords() {
        const newPass = document.getElementById("newPassword").value;
        const repeatPass = document.getElementById("repeatPassword").value;
        let isValid = 
        $("#resetPasswordSubmit").prop('disabled', !(newPass.length >= 6 && newPass === repeatPass));
    }

    resetPass(evt){
        const password = document.getElementById("newPassword").value;
        RestService.resetPassword(password).then((result)=>{
            const profile = restService.getProfile();
            const hostUrl = this.hostUrl;
            if (util.isTrue(profile.HtmlDashboardEnabled)){

                //PF-8390 If a basic user has a report assigned it should display the report and not the dashboard
                if(profile.HomeReport && profile.HomeReport !== ""){
                    RestService.playForm(profile.HomeReport);
                    return;
                }

                Backbone.history.loadUrl('greeting');
            }else{
               util.pf_main('100%', '100%', hostUrl + '/main.aspx', '&g=' + hostUrl + '&t=' + restService.getToken() + '&u=' + restService.getProfile().AccountName);
            }
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });        
    }

    backToLogin(){
        Backbone.history.loadUrl('login');
    }

    render() {
        $(this.el).html(this.template(this.model.toJSON()));
        $(this.el).parent().addClass('blue-background');
        this.delegateEvents();
        return this;
    }
}

export default ResetPasswordView;
